;(function($){

	/* Helper function für idangerous swiper  */
	$.fn.shopgateSwiper = function(options) {
		if (typeof $.fn.swiper != 'function'){console.error('swiper not loaded'); return false;};

		var defaults = {
			swiperConf: {
				mode:'horizontal',
				loop: true,
				paginationClickable: true,
				pagination: '.pagination',
				grabCursor: true,
				wrapperClass: 'swiper-wrapper',
				slideClass: 'swiper-slide',
				slideElement: 'div'
			},
			swiperContainerClass: 'swiper-container',
			useCustomClasses: false
		};

		options = options || {};
		options = $.extend(true, {}, defaults, options);

		// default classes für CSS anhängen
		if(options.useCustomClasses){
			this.addClass(defaults.swiperContainerClass);
			$('.'+ options.swiperConf.wrapperClass, this).addClass(defaults.swiperConf.wrapperClass);
			$('.'+ options.swiperConf.slideClass, this).addClass(defaults.swiperConf.slideClass);
		}
			
		return this.swiper(options.swiperConf);
	};
	
	$.fn.shopgateSlider = function(options) {
		var defaults = {
			sliderOptions: {
				adaptiveHeight: true,
				pager: false,
				controls: false,
				infiniteLoop: true,
				auto: true,
				pause: 5000
			},
			htmlWrapperClass: 'startpage-custom-html-wrapper'
		},
		legacyWrapperMargin = null;

		options = $.extend(true, {}, defaults, options);

		return this.each(function() {
			var that = $(this),
				currentSliderOptions = $.extend(true, {}, options.sliderOptions, that.data());	

			currentSliderOptions.onSliderLoad = _onSliderLoad;

			// CSS fuer alten Teaser-Style nachtragen
			_addLegacyCss(that);

			that.children().prop('draggable', false);
			that.find('a').prop('draggable', false);

			// Slider initialisieren
			that.bxSlider(currentSliderOptions);

			function _onSliderLoad() {

				var sliderWrapper = that.parentsUntil('.bx-wrapper').parent();
				
				if (currentSliderOptions.pager) {
					var oldMarginBottom = parseInt(sliderWrapper.css('margin-bottom'), 10),
						pagerHeight = sliderWrapper.find('.bx-pager').outerHeight(true);

					sliderWrapper.css('margin-bottom', oldMarginBottom + pagerHeight);
				}

				if (currentSliderOptions.controls) {
					sliderWrapper.find('.bx-prev, .bx-next').append('<span class="button"></span>');
				}
			}
		});

		function _addLegacyCss(that) {
			var htmlWrapper = null,
				htmlWrapperMargin = null,
				tilesCss = null;

			if (that.parent().hasClass(options.htmlWrapperClass)) {
				htmlWrapper = that.parent();
			} else {
				htmlWrapper = that.parentsUntil('.' + options.htmlWrapperClass).parent();
			}

			if (htmlWrapper.hasClass(options.htmlWrapperClass)) {
				htmlWrapperMargin = legacyWrapperMargin ? legacyWrapperMargin : htmlWrapper.css('padding-left');
				tilesCss = {'margin-left': htmlWrapperMargin, 'margin-right': htmlWrapperMargin};
				
				if (!htmlWrapperMargin) {
					htmlWrapper.css({'padding-left': 0, 'padding-right': 0});
				}
			
				that.find('.custom-wrapper-tile').css({'margin': 5}).css(tilesCss);
				htmlWrapper.find('.custom-wrapper-tiles').css(tilesCss);	
			}
		}
	};
	
})(jQuery);


// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-slider.js